import { FC, Suspense } from 'react';
import { UnitFocus } from './UnitFocus';
import { UnitFocusSkeleton } from './UnitFocusSkeleton';
import { UnitFocusNoClassState } from './UnitFocusNoClassState';
import { useClassFocusOnboarding } from '../../contexts/ClassFocusOnboardingContext';

interface UnitClass {
  id: string;
  name: string;
}

interface Props {
  currentClass: UnitClass | null;
}

export const UnitProgressWidget: FC<Props> = ({ currentClass }) => {
  // focusAnchorRef lets the onboarding task scroll the widget clear of the fixed footer. It sits on
  // the widget rather than the action row so the scroll works in every state — loading, no class in
  // scope, or fully loaded (see ClassFocusOnboardingContext).
  const { focusAnchorRef } = useClassFocusOnboarding();

  return (
    <div
      ref={focusAnchorRef}
      className="w-full mb-4 tw-flex tw-flex-col tw-items-start tw-justify-center tw-gap-5 tw-py-6 tw-px-8 tw-bg-white tw-border-[#F1F0EE] tw-border-4 tw-border-solid tw-rounded-2xl"
    >
      <div className="tw-flex tw-w-full tw-flex-col tw-gap-1">
        <h3 className="tw-justify-start tw-text-xl tw-font-bold tw-font-sora tw-leading-7 tw-text-neutral-950">
          Unit Progress
        </h3>
        <div className="tw-w-full tw-h-0.5 tw-bg-neutral-100 tw-rounded-full" />
      </div>
      <Suspense fallback={<UnitFocusSkeleton />}>
        {currentClass ? <UnitFocus key={currentClass.id} unitClass={currentClass} /> : <UnitFocusNoClassState />}
      </Suspense>
    </div>
  );
};
